import { z } from "zod";
import { AgencyIdSchema, ProjectIdSchema } from "../primitives/ids.js";
export const SiteHealthMonitorKindSchema = z.enum([
    "AVAILABILITY",
    "TLS_CERTIFICATE",
    "DOMAIN_DNS",
    "CRITICAL_BREAKAGE",
    "QUALITY_DRIFT",
]);
export const SiteHealthMonitorStatusSchema = z.enum(["HEALTHY", "DEGRADED", "CRITICAL", "UNKNOWN"]);
export const SiteHealthMonitorV1Schema = z
    .object({
    schemaVersion: z.literal("site-health-monitor.v1.0"),
    monitorId: z.string(),
    agencyId: AgencyIdSchema,
    projectId: ProjectIdSchema,
    kind: SiteHealthMonitorKindSchema,
    status: SiteHealthMonitorStatusSchema,
    evidenceSummary: z.string(),
    checkedAt: z.string().datetime(),
})
    .strict();
export const SiteHealthSnapshotV1Schema = z
    .object({
    schemaVersion: z.literal("site-health-snapshot.v1.0"),
    agencyId: AgencyIdSchema,
    projectId: ProjectIdSchema,
    monitors: z.array(SiteHealthMonitorV1Schema),
    generatedAt: z.string().datetime(),
})
    .strict();
//# sourceMappingURL=care-site-health.js.map